export default __webpack_public_path__ + "static/media/home-startup-slider-bg-02.4079b384.jpg";